<div class="onboarding-finalize">
  <c-card class="shadow-sm">
    <c-card-header>
      <strong>{{ "ONBOARDING_FINALIZE.TITLE" | translate }}</strong>
    </c-card-header>
    <c-card-body>
      <p class="text-muted">
        {{ "ONBOARDING_FINALIZE.DESCRIPTION" | translate }}
      </p>

      @if (status; as currentStatus) {
      <div class="onboarding-finalize__steps">
        <div class="onboarding-finalize__row">
          <span>{{ "ONBOARDING_FINALIZE.STEPS.SURVEY" | translate }}</span>
          <span>{{
            currentStatus.steps.survey.completed
              ? ("ONBOARDING_FINALIZE.STATUS.COMPLETE" | translate)
              : ("ONBOARDING_FINALIZE.STATUS.INCOMPLETE" | translate)
          }}</span>
        </div>
        <div class="onboarding-finalize__row">
          <span>{{ "ONBOARDING_FINALIZE.STEPS.PROFILE" | translate }}</span>
          <span>{{
            currentStatus.steps.profile.completed
              ? ("ONBOARDING_FINALIZE.STATUS.COMPLETE" | translate)
              : ("ONBOARDING_FINALIZE.STATUS.INCOMPLETE" | translate)
          }}</span>
        </div>
        @if (!isDefaultPlusCompany) {
        <div class="onboarding-finalize__row">
          <span>{{ getSetupStepLabel() }}</span>
          <span>{{ getSetupStepStatus(currentStatus) }}</span>
        </div>
        }
      </div>
      } @if (status && !canFinalize) {
      <c-alert color="warning">
        {{ getPreviousStepsMessage() }}
      </c-alert>
      } @if (isProcessing) {
      <div class="onboarding-finalize__progress">
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="progress"></div>
        </div>
        <p class="progress-stage">{{ currentStage }}</p>
      </div>
      } @if (errorMessage) {
      <c-alert color="danger">
        {{ errorMessage }}
      </c-alert>
      }

      <div class="d-flex flex-wrap gap-2 mt-3">
        <button
          cButton
          class="btn--primary-gradient"
          (click)="finalize()"
          [disabled]="!canFinalize || isProcessing"
        >
          {{ "ONBOARDING_FINALIZE.ACTIONS.FINISH" | translate }}
        </button>
        @if (!isDefaultPlusCompany) {
        <a
          cButton
          color="secondary"
          [routerLink]="setupRoute"
          [class.disabled]="isProcessing"
          [attr.aria-disabled]="isProcessing"
        >
          {{ "ONBOARDING_FINALIZE.ACTIONS.BACK_TO_SETUP" | translate }}
        </a>
        }
      </div>
    </c-card-body>
  </c-card>
</div>
